<template>
  <div class="container-new-runpayroll">
    <div class="main-container-spacing">
      <div class="runpayroll-div">
        <div class="select-items">
          <p class="financilaYear">
            Financial Year: {{ financialYear }}
          </p>
          <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px" class="date-select">
            <template v-slot:activator="{ on, attrs }">
              <div class="curved-div" style="gap: 20px;" v-bind="attrs" v-on="on">
                {{ formattedDate }}
                <img src="@/assets/stroke-1.svg">
              </div>
            </template>
            <v-date-picker v-model="dateValue" :allowed-dates="allowedMonths" :picker-date="initialPickerDate"
              type="month" color="#5D409F" class="dat-picker" @input="menu = false"></v-date-picker>
            <template v-slot:actions>
              <v-btn text @click="clearDate">Clear</v-btn>
              <v-btn text>Today</v-btn>
            </template>
          </v-menu>
          <div class="curved-div">
            <v-autocomplete filled class="multi" chips multiple v-model="selectedItems" :items="paygroups"
              item-text="payGroupName" item-value="id" hide-no-data label="" placeholder="Select Paygroup"
              deletable-chips clerable return-object @change="onPaygroupChange">
              <template v-slot:selection="{ item, index }" style="font-size: 400;">
                <span v-if="index === 0" style="font-size: inherit; user-select: none;">
                  {{ selectPaygroupText }}
                </span>
              </template>
            </v-autocomplete>
          </div>
          <div class="circle-wrapper">
            <div class="circle">{{ selectedItems.length }}</div>
            <div class="tooltip">
              <ul>
                <li v-for="item in selectedItems" :key="item.id">{{ item.payGroupName }}</li>
              </ul>
            </div>
          </div>
          <btn v-if=" !isPayrollProcessed" :text="'Selected Employees'" type="secondary" class="rollback-button"
            @click="selectEmployees">
          </btn>
        </div>
        <div class="runpayroll">
          <img src="@/assets/auditlog.svg" @click="aduitLog()">
          <!-- Finalize Payroll Button: Only visible and enabled when thisPayrollCompleted is true -->
          <btn v-if="!isPayrollProcessed " :text="'Finalize Payroll'" @click="finalizePayroll" type="secondary"
            :disabled="!isFinalizePayrollEnabled" class="rollback-button">
          </btn>

          <!-- Save Payroll Button: Appears only when thisPayrollCompleted is false -->
          <btn v-if=" !isPayrollProcessed " :text="btnText" type="primary" class="runpayroll-button"
            @click="savePayroll"></btn>

          <!-- Rollback Payroll Button: Replaces Save Payroll after payroll is processed -->

          <btn v-if="isPayrollProcessed" :text="'Run Payroll'" type="primary" class="runpayroll-button"
            @click="rollBack">
          </btn>

          <!-- <btn v-if="thisPayrollCompleted" :text="'Finalize Payroll'" @click="finalizePayroll" type="primary" class="runpayroll-button"></btn>
          <btn  :text="btnText" type="primary" class="runpayroll-button" @click="savePayroll">
          </btn> -->
          <!-- <btn v-if="!isPayrollProcessed" v-else :text="'Rollback Payroll'" type="secondary" class="rollback-button" @click="rollBack()">
          </btn> -->
        </div>

      </div>
      <div style="width: 100%;">
        <div class="payroll-row">
          <!-- Big Box -->
          <div class="process-payroll-container">
            <div class="doughnut-container">
              <div class="text-center">
                <!-- <v-progress-circular :value="payrollStatus" :rotate="-90" :size="160" :width="25" color="#62BDBD"
                  class="doughnut-progress">
                  <template v-slot:default>
                    <div class="doughnut-circle">
                      {{ payrollStatus }} %
                    </div>
                  </template>
                </v-progress-circular> -->
                <!-- <btn v-if="!thisPayrollCompleted && !isPayrollProcessed || webSocketFlag" :text="'Refresh'"
                type="secondary" class="rollback-button"  :icon="require('@/assets/refreshNew.svg')" @click="payrollStatusItem">
              </btn> -->
                <v-btn
                  style="padding: 20px;color: #5D409F; padding-top: 25px; padding-bottom: 25px; border-radius: 50px;"
                  color="white" class="rollback-button" @click="payrollStatusItem">
                  <!-- Custom image icon -->
                  <img src="@/assets/refreshNew.svg" style="width: 40px; margin-right: 5px;"
                    :class="{ 'rotate': isRotating }" :title="'Please refresh the button to get the payroll status'">
                  Refresh
                </v-btn>
              </div>
              <p style="color: #5D409F;">
                Status:
                <span
                  :class="statusOfPayroll === 'RUNNING' ? 'running-status' : statusOfPayroll === 'COMPLETED' ? 'completed-status' : ''">
                  {{ statusOfPayroll ? statusOfPayroll : 'Pending' }}
                </span>
              </p>
              <div class="employee-ratio">
                <p class="totl-emp">{{ filteredCountDetails[0] && filteredCountDetails[0].eligibleEmployees }} / {{
                  filteredCountDetails[0] && filteredCountDetails[0].totalEmployess }}</p>
                <p style="font-size: 18px;">Employee</p>
              </div>
            </div>
            <div>
              <div class="employee-details">
                <div class="employee-count">
                  <p class="employee-p">{{ filteredCountDetails[0] && filteredCountDetails[0].newJoineese }}</p>
                  <p class="employee-details-heading">New Joiners</p>
                </div>
                <div class="employee-count">
                  <p class="employee-p">{{ filteredCountDetails[0] && filteredCountDetails[0].eligibleEmployees }}</p>
                  <p class="employee-details-heading">Active</p>
                </div>
                <div class="employee-count">
                  <p class="employee-p">{{ filteredCountDetails[0] && filteredCountDetails[0].resignees }}</p>
                  <p class="employee-details-heading">Resignees</p>
                </div>
                <div class="employee-count">
                  <p class="employee-p">{{ filteredCountDetails[0] && filteredCountDetails[0].fullAndFinal }}</p>
                  <p class="employee-details-heading">Full & Final</p>
                </div>
              </div>
            </div>
          </div>
          <!-- Small Boxes -->
          <div class="small-boxes">
            <div class="small-box-with-text">
              <p class="calender-days">Calculation Summary</p>
              <img src="@/assets/info-2.svg" style="width: 20px;" :title="'A breif summary of earnings and deductions'">

            </div>

            <div v-if="isLoadingGross" class="gross-outer-container">
              <div v-for="n in 4" :key="n" class="custom-skeleton" style="height: 225px; width: 100%;">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                  <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
                </v-sheet>
              </div>
            </div>
            <div v-else class="gross-outer-container">

              <div v-for="(item, index) in payrollData" :key="index" class="gross-container">

                <div class="gross-items">
                  <p class="employee-ptext">{{ index }}</p>
                  <img src="@/assets/info-2.svg" style="width: 20px;" :title="item.tooltip" />
                </div>
                <p class="gross-inr">INR</p>
                <p class="gross-value">₹ {{ item.total }}</p>
                <div class="income-container" style="margin-top: 25px;">
                  <div class="dashed-container">
                    <img
                      :src="item.flag === 'up' ? require('@/assets/inrIncrease.svg') : require('@/assets/inrDecrease.svg')"
                      alt="Flag Indicator" />
                    <p class="variation-ptext">{{ item.prevTotal }}</p>
                  </div>
                  <img src="@/assets/payrollwarning.svg" :title="'Increase in gross items'" />
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
    <div v-if="!isPayrollProcessed">
      <before-payroll :date="dateValue" :selected-items="selectedItems" @audit-data-emitted="updateAuditData"
        @vali-data-emitted="validationItem" />
    </div>
    <div v-else>
      <payroll-actions :key="isPayrollProcessed" :date="initialPickerDate" :selected-items="selectedItems"
        @audit-data-emitted="udateAfterAuditData" />

    </div>
    <pop-up-message v-if="showWarning" :popupType="'Warning'" :popupHeaderMessage="'Actions Pending'"
      :message="warningMessage">
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Ok" type="primary" @click="goBack" />
        </btn-grp>
      </template>
    </pop-up-message>
    <v-dialog v-model="showRollBackPopUp" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          <p class="rollBackDaillog">Are you sure you want to roll back?</p>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <p style="margin-bottom: 0px;">Remarks*:
            <span :class="{ 'bold-text': remarksWithoutSpaces < 15, 'light-text': remarksWithoutSpaces >= 15 }">
              (Min of 15 Characters required)
            </span>
          </p>
          <textarea class="form-control custom-textarea margintop-16" rows="15" name="selectEmp"
            placeholder="Enter the Remarks" v-model="remarks"></textarea>
        </v-card-text>
        <v-divider class="divider"></v-divider>

        <v-card-actions style="margin-top: 10px;">
          <v-spacer></v-spacer>
          <v-btn class="rollbackCancel" text @click="rollbackPopUpClose">Cancel</v-btn>
          <v-btn class="rollBtn" :disabled="remarksWithoutSpaces < 15" style="background-color:#5D409F;" text
            @click="rollbackSubmit">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <pop-up-message popupHeaderMessage="Warning" v-if="showLockPopupModal"
      message="Are you sure you want to Lock this month Payroll" :popupType="'Warning'">
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="no">
            <b>No</b>
          </button>
          <button class="btn-popup" type="button" @click="lockPayroll">
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>

    <roll-back-dailog :showDialog="rollBackPopUp" :paygroups="paygroups" :paygroupItemText="'payGroupName'"
      :paygroupItemValue="'id'" v-model:selectedPaygroup="rollBackPygroup" @close="handleDialogClose"
      @next="handleNextClick" />
    <v-dialog v-model="aduitPopup" width="500" persistent>
      <v-card>
        <v-card-title class="aduit-title">
          <div class="aduit-container">
            <p style="padding-top: 10px;">Audit Log</p>
          </div>
        </v-card-title>
        <v-card-text class="aduit-card-text">
          <div v-for="(item, index) in aduitItemsProp" :key="index" class="audit-items-data">
            <div class="aduit-items-div">
              <div class="aduit-description">
                <div class="aduit-dis">
                  <p class="aduit-pText">{{ item.name }}({{ item.email }})</p>
                  <p style="margin-bottom: 0px;">{{ item.description }}</p>
                </div>
              </div>
              <p>{{ item.date }}</p>
            </div>
            <v-divider></v-divider>
          </div>
        </v-card-text>
        <v-divider class="divider"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="aduitPopup = false" class="aduit-close-button">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pop-up-message v-if="showModal" :message="responseMessage" btnText="OK" @back="closeModal()"></pop-up-message>
  </div>
</template>


<script>
import PayrollActions from "./payrollActions.vue";

// import StandardReport from "./standardReport.vue";
import BeforePayroll from "./beforePayroll.vue"
// import { VSkeletonLoader } from 'vuetify/lib/components';
import RollBackDailog from './rollBackDailog.vue';
import { mapActions, mapGetters, mapState } from "vuex";


export default {
  components: {
    PayrollActions,
    RollBackDailog,
    // StandardReport,
    BeforePayroll

  },
  data() {
    return {
      payrollStatus: null,
      btnText: 'Run Payroll',
      isPayrollProcessed: false,
      details: "",
      statusOfPayroll: '',
      selectPaygroupText: 'Select Paygroup',
      dateValue: '',
      isRotating: false,
      validationCheck: '',
      selectedEmployeesArray:[],
      showModal: false,
      webSocketFlag: false,
      showRollBackPopUp: false,
      aduitPopup: false,
      aduitItemsProp: [],
      showLockPopupModal: false,
      rollBackPopUp: false,
      dialog: false,
      thisPayrollCompleted: true,
      showWarning: false,
      showWarningValidation: false,
      isLoadingGross: true,
      financialYear: '',
      responseMessage: '',
      theme: {
        isDark: false, // Set to true for dark mode
      },
      menu: false,
      menu2: false,
      warningMessage: '',
      warningMessageValidation: '',
      initialPickerDate: '',
      legalEntityName: '',
      selectedDate: null,
      payrollData: [],
      paygroups: [],
      selectedItems: [],
      rollBackPygroup: [],
      value: 70,
      showDatePicker: false,
      selectedDate: null,
      firstPayrollMonth: '',
      firstPayrollYear: '',
      // firstPayrollDate: '',
      startingMonth: '',
      templeId: '',
      initialValue: '',
      paygroupsData: [],
      countDetailsArray: [],
      selectedDetailsArray:[],
      filteredCountDetails: [],
      errmsg: "",
      toast: false,
      remarks:"",
      monthMap : {
        jan: 'January', feb: 'February', mar: 'March', apr: 'April',
        may: 'May', jun: 'June', jul: 'July', aug: 'August',
        sep: 'September', oct: 'October', nov: 'November', dec: 'December'
      }
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getDasLeid: "onboard/legal_entities/selectedLegalEntityId",
    }),
    ...mapState({
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      selectedEmployeesData: state => state.payroll.paygroups.employeeData,
      isSelected: state => state.payroll.paygroups.isSelectedEmployees,
      totalPayGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      entities: state => state.onboard.legal_entities.data
    }),
    leitem() {
      const item = localStorage.getItem('selectedLegalEntityId')
      return item
    },
    getLeId() {
      return getDasLeid
    },
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
    isFinalizePayrollEnabled() {
      return this.statusOfPayroll === 'COMPLETED';
    },
    formattedDate() {
      if (!this.dateValue) return this.initialValue;
      const [year, month] = this.dateValue.split('-');
      const date = new Date(year, month - 1); // Convert to Date object
      return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' }).format(date);
    },
    formattedPayrollYear() {
      return this.dateValue.split('-')[0];
    },
    formattedPayrollMonth() {
      const monthNumber = this.dateValue.split('-')[1];
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return monthNames[parseInt(monthNumber, 10) - 1];
    },
    remarksWithoutSpaces() {
      return this.remarks.replace(/\s/g, "").length;
    },
  },
  created() {
    this.templeId = localStorage.getItem('selectedLegalEntityId');
  },
  watch: {
    isPayrollProcessed(newVal) {
      if (newVal === true || newVal === false) {
        // Call the fetchAudit based on whether payroll is processed or not
        // this.fetchAudit();
      }
    },
  },
  mounted() {
    this.cycleDate();
    // this.templeId = localStorage.getItem('selectedLegalEntityId');
    // this.socket = new WebSocket(process.env.VUE_APP_WEBSOCKET);

    // this.socket.addEventListener('open', (event) => {
    //   console.log('WebSocket connection opened');
    // });

    // this.socket.addEventListener('message', (event) => {
    //   let dataArray = JSON.parse(event.data);
    //   let completed = [];

    //   if (!dataArray || dataArray.length === 0) {
    //     console.log('No data received from WebSocket');
    //     this.webSocketFlag = true;  // Set the error flag if data is null or empty
    //     console.log(this.webSocketFlag, 'this.webSocketFlag');
    //     return;
    //   } else {
    //     this.webSocketFlag = false;
    //   }

    //   let result = dataArray.find(x => x.data.legal_entity_id == this.le_id);
    //   console.log(result, 'result.progress in first');

    //   if (!result || !result.progress) {
    //     console.log('Result or progress not found', result);
    //     this.webSocketFlag = true;  // Set the error flag if result is undefined or progress is missing
    //     return;
    //   }

    //   console.log(result, 'result.progress');

    //   // Check progress value and set flags accordingly
    //   if (result.progress < 100) {
    //     this.thisPayrollCompleted = true;
    //   } else {
    //     this.thisPayrollCompleted = false;
    //   }

    //   this.payrollStatus = result.progress || 0;  // Set to 0 if result.progress is undefined

    //   console.log(this.thisPayrollCompleted, result.progress, 'this.thisPayrollCompleted');
    //   console.log(this.payrollStatus, 'payrollStatus');

    //   completed.push(result);

    //   if (event.data == null) {
    //     this.socket.addEventListener('close', (event) => {
    //       console.log('WebSocket connection closed');
    //     });
    //   }
    // });

    this.updateAuditData();
  },

  methods: {
    ...mapActions({
      // act_fetchAll: "payroll/paygroups/fetchAll",
      act_fetchAllgross: "payroll/paygroups/fetchdetailsgross",
      act_getPayrollStatus: "payroll/paygroups/getPayrollStatus",
      act_fetchAduitLogs: "payroll/paygroups/fetchdetailsAduit",
      act_validation_before: "payroll/paygroups/fetchValidationDetailsBefore",
      act_getLockActions: "payroll/paygroups/fetchdetailsLockActions",
      act_getCount_details: "payroll/paygroups/fetchCountdetails",
      act_insert: "payroll/paygroups/fetchdetailsAduitInsert"
      , act_create: "payroll/runpayroll/create",
      // act_getLockedPayrollMonth: 'dashboard/payroll/monthlypayroll/lockPayroll/getLockedPayrollMonth',
      // act_payroll_cycle_data: "onboard/settings/payroll_cycle/fetchAll",
      act_exact_cycle: "payroll/paygroups/fetchExactCycle",
      // act_postLockActions:"payroll/paygroups/fetchdetailsLockActionsInsert",
      // act_getLockActions:"payroll/paygroups/fetchdetailsLockActions",
      // act_patchLockActions:"payroll/paygroups/fetchdetailsLockActionsPatch",
      act_rollBack: "payroll/paygroups/fetchrollBack",
      act_setPayrollMonth: "payroll/runpayroll/setPayrollMonth",
    }),
    aduitLog() {
      this.aduitPopup = true
    },
    selectEmployees() {
      this.rollBackPopUp = true

    },
    rollBack() {
      // this.isPayrollProcessed = false;
      // this.showRollBackPopUp = true
      this.rollbackSubmit();

    },
    rollbackPopUpClose() {
      this.showRollBackPopUp = false

    },
    async rollbackSubmit() {
      try {
        let obj = {
          updated_by: localStorage.getItem('loginId'),
          remarks: this.remarks,
        }
        const res = await this.act_rollBack(obj)
        if (res) {
          this.isPayrollProcessed = false;
          //this.showRollBackPopUp = false;
          this.remarks = "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    closeModal() {
      this.showModal = false
    },
    handleDialogClose() {
      this.rollBackPopUp = false;
    },
    handleNextClick(data) {
      // this.isPayrollProcessed = false;
      this.rollBackPopUp = false;
      this.selectedEmployeesArray = data.employeeCodes
    },
    allowedMonths(date) {
      const selectedYear = new Date(date).getFullYear();
      const allowedYear = new Date(this.firstPayrollYear).getFullYear();
      const allowedMonth = this.startingMonth;
      return selectedYear === allowedYear && new Date(date).getMonth() + 1 === allowedMonth;
    },
    async updateAuditData(data) {
      // this.aduitItemsProp = data;
      this.aduitItemsProp = data.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA;
      });
      this.auditPopup = true; // Open the dialog
    },
    async validationItem(data) {
      this.validationCheck = data
    },
    async udateAfterAuditData(data) {
      // this.aduitItemsProp = data;
      this.aduitItemsProp = data.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA;
      });
      this.auditPopup = true;
    },
    async fetchGross() {
      this.isLoadingGross = true;
      try {
        const res = await this.act_fetchAllgross({
          month: this.firstPayrollMonth, financial_year: this.firstPayrollYear, legal_entity_id: this.le_id
        })
        setTimeout(() => {
          this.payrollData = res.data.payload;
          this.isLoadingGross = false; // End loading after delay
        }, 200);
        this.payrollData = res.data.payload
      } catch (error) {
        console.log(error, 'error')
        this, isLoadingGross = true
      } finally {
        this.isLoadingGross = false; // End loading
      }
    },
    async payrollStatusItem() {
      try {
        const monthMap = {
          jan: 'January', feb: 'February', mar: 'March', apr: 'April',
          may: 'May', jun: 'June', jul: 'July', aug: 'August',
          sep: 'September', oct: 'October', nov: 'November', dec: 'December'
        };

        // Convert `firstPayrollMonth` to full name if it's in abbreviation
        const fullMonthName = monthMap[this.firstPayrollMonth.toLowerCase()] || this.firstPayrollMonth;
        const res = await this.act_getPayrollStatus({
          month: fullMonthName, financial_year: this.firstPayrollYear, legal_entity_id: this.le_id
        })
        this.isRotating = true;

        // Reset rotation state after animation duration (1 second in this case)
        setTimeout(() => {
          this.isRotating = false;
        }, 1000); // Match this duration to the animation duration

        this.statusOfPayroll = res.data.payload.status
      } catch (e) {

      }
    },
    async cycleDate() {
      try {
        let obj = { 'le_id': this.le_id };
        let res = await this.act_exact_cycle(obj)
        this.firstPayrollYear = res.data.payload.financialYear
        // let monthArray =['jan','feb','mar']
        // const monthInArray = monthArray.includes(res.data.payload.month)
        //  if(monthInArray)
        //  {
        //   this.firstPayrollYear = parseInt(this.firstPayrollYear)-1
        //  }
        const nextYear = parseInt(this.firstPayrollYear) + 1;
        this.financialYear = `${this.firstPayrollYear}-${nextYear}`;
        this.startingMonth = this.convertMonthToNumber(res.data.payload.month)
        this.firstPayrollMonth = res.data.payload.month;
        this.initialPickerDate = `${this.firstPayrollYear}-${String(this.startingMonth).padStart(2, '0')}`;
        this.initialValue = this.convertToMonthYearFormat(this.initialPickerDate);
        let data = {
          month: this.monthMap[res.data.payload.month],
          year: res.data.payload.financialYear.toString(),
        };
        await this.act_setPayrollMonth(data);
        if (res) {
          this.countDetails()
          this.fetchGross()
          this.payrollStatusItem();
          // this.getValidation()
          //this.fetchAudit()
          // this.fetchAuditInsert()
        }
      } catch (e) {
        console.log(e)

      }
    },
    convertToMonthYearFormat(date) {
      const [year, month] = date.split('-');
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
    },
    convertMonthToNumber(monthString) {
      const months = {
        'jan': 1, 'feb': 2, 'mar': 3, 'apr': 4, 'may': 5, 'jun': 6,
        'jul': 7, 'aug': 8, 'sep': 9, 'oct': 10, 'nov': 11, 'dec': 12
      };
      return months[monthString.toLowerCase()];
    },
    calculateFinancialYear(startingYear, startingMonth) {
      if (startingMonth >= 4) {
        return `${startingYear}-${startingYear + 1}`;
      } else {
        return `${startingYear - 1}-${startingYear}`;
      }
    },
    goBack() {
      this.showWarning = false
    },
    validationGoBack() {
      this.showWarningValidation = false
    },
    async finalizePayroll() {
      this.payrollStatusItem();
      this.isPayrollProcessed = true;
    },
    async savePayroll() {
      //   if (!this.formattedPayrollMonth || !this.formattedPayrollYear || this.selectedItems.length === 0) {
      //   if (!this.initialValue || this.selectedItems.length === 0) {
      //     this.warningMessage = 'Please select the payroll month and paygroup before running payroll.';
      //     this.showWarning = true;
      //     return;
      //   }
      // }
      // const hasIncompleteItems =
      //   (this.validationCheck.Actions && this.validationCheck.Actions.some(item => {
      //     // Check if any of the specific items are complete
      //     // if (item.name === 'Transfer IT Proof' || item.name === 'Transfer IT Declaration' || item.name === 'FBP Lock') {
      //     //   return item.status === 'complete'; 
      //     // }
      //     // return item.status === 'incomplete'; 
      //   })) ||
      //   (this.validationCheck.Payroll && this.validationCheck.Payroll.some(item => item.status === 'incomplete')) ||
      //   (this.validationCheck.Pending && this.validationCheck.Pending.some(item => item.status === 'incomplete'));
       
      const hasIncompleteItems =
        // Directly check if any array is empty
        (this.validationCheck.Actions.length === 0 || this.validationCheck.Payroll.length === 0 || this.validationCheck.Pending.length === 0) ||
        (this.validationCheck.Payroll.some(item => item.status === 'incomplete')) ||
        (this.validationCheck.Pending.some(item => item.status === 'incomplete'));
      if (hasIncompleteItems) {
        this.warningMessage = 'Please accept all the pending actions';
        this.showWarning = true;
        return;
      }

      if (hasIncompleteItems) {
        this.warningMessage = 'Please accept all the pending actions';
        this.showWarning = true;
        return;
      }
      const matchingEntity = this.entities.find(entity => entity.id === this.le_id);
      this.legalEntityName = matchingEntity ? matchingEntity.legalName : null;
      const paygroups = this.selectedItems.map(item => ({ id: item.id }));

      try {
        let obj = {
          paygroups: paygroups,
          legal_entity_id: this.le_id,
          legal_entity_name: this.legalEntityName,
          month: this.firstPayrollMonth,
          financial_year: this.firstPayrollYear,
          employeeIds: this.selectedEmployeesArray || [],
          total_employees: this.filteredCountDetails[0].eligibleEmployees
        };
        try {
          // this.$root._data.isSaving = true;
          let res = await this.act_create(obj);
          this.fetchGross()
          this.payrollStatusItem();
          setTimeout(() => {
            if (res.status) {
              this.showModal = true;
              this.responseMessage = 'Payroll processing is currently underway, we invite you to monitor the progress and status on the dashboard.';
            }
            // this.isPayrollProcessed = true;
            // this.$root._data.isSaving = false;
          }, 500)
        } catch (err) {
          // this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }

    },

    async countDetails() {
      try {
        const res = await this.act_getCount_details({ le_id: this.le_id, payroll_month: this.firstPayrollMonth, financial_year: this.firstPayrollYear })
        this.countDetailsArray = res.data.payload.data
        this.countDetailsArray = {
          totalEmployess: res.data.payload.totalEmployess,
          newJoineese: res.data.payload.newJoineese,
          eligibleEmployees: res.data.payload.eligibleEmployees,
          resignees: res.data.payload.resignees,
          fullAndFinal: res.data.payload.fullAndFinal
        };
        this.selectedDetailsArray = res.data.payload.data
        this.paygroups = res.data.payload.data.map(item => ({
          payGroupName: item.payGroupName,
          id: item.id
        }));
        this.selectedItems = this.paygroups;
        this.filteredCountDetails = [this.countDetailsArray];

      } catch (e) {

      }
    },
    onPaygroupChange() {
      // Filter the count details array based on selected paygroup(s)
      if (this.selectedItems.length > 0) {
        this.filteredCountDetails = this.selectedDetailsArray.filter(item =>
          this.selectedItems.some(selected => selected.id === item.id)
        );
      } else {
        // If no paygroup is selected, show all data
        this.filteredCountDetails = this.countDetailsArray;
      }
    },
    clearDate() {
      this.dateValue = '';
    },
    toggleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
    },
    handleDateSelect(val) {
      this.selectedDate = val;
      this.showDatePicker = false;
    },
    closeDatePicker() {
      this.showDatePicker = false;
    },

  },
};
</script>
<style lang="scss" scoped>
.container-new-runpayroll {
  width: 100%;
  background-color: #F2F2F2;
}

// ::v-deep .v-dialog__content{
//   background: rgba(0, 0, 0, 0.6);
//   backdrop-filter: blur(10px);
// }
.runpayroll-div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

/* Apply the rotation animation when isRotating is true */
.rotate {
  animation: rotate 1s linear;
}

.select-items {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 0px;
}

.runpayroll {
  display: flex;
  gap: 15px;
}

.aduit-title {
  color: #5D409F;
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
}

.aduit-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
}

.aduit-card-text {
  padding: 10px 0px;
  max-height: 250px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.grayed-out {
  opacity: 0.5;
  pointer-events: none;
  /* Prevent any user interactions */
}

.loader-sheet {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.loader {
  margin-bottom: 20px;
  width: 100%;
  max-width: 400px;
  /* You can adjust this value */
}

.audit-items-data {
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
  gap: 14px;
}

.aduit-items-div {
  display: flex;
  justify-content: space-between;
  padding: 0px 16px;
}

.aduit-description {
  display: flex;
  gap: 14px;
}
/* Define the glowing red text animation without text-shadow */
@keyframes redGlow {
  0%, 100% {
    color: #E80000;
    opacity: 1;
  }
  50% {
    color: #ff4d4d;
    opacity: 0.5;
  }
}

/* Red glow animation for RUNNING status */
.running-status {
  animation: redGlow 1.5s infinite ease-in-out;
  font-weight: bold;
}

/* Green color for COMPLETED status */
.completed-status {
  color: #00B430;
  font-weight: bold;
}




.aduit-dis {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rollBackDaillog {
  font-size: 18px;
  margin-bottom: 0px;
  color: #5D409F;
  font-size: 16px;
  font-weight: bold;
}

.rollbackCancel {
  border: 1px solid #59419A;
  padding: 20px 40px;
  border-radius: 5px;
  color: #59419A
}

.rollBtn {
  border-radius: 5px;
  padding: 20px 40px;
  border-radius: 5px;
  color: #FFFFFF
}

.custom-skeleton {
  position: relative;
  overflow: hidden;
  background: #f0f0f0;
}

.custom-skeleton::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.1) 25%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.1) 75%);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.aduit-pText {
  color: #3C3C3C;
  font-weight: 500;
  margin-bottom: 0px
}

.aduit-close-button {
  border: 1px solid #59419A;
  padding: 20px 40px;
  border-radius: 5px;
  color: #59419A
}

.financilaYear {
  color: #59419A;
  font-size: 16px;
  font-family: Montserrat;
  font-weight: bold;
  margin-bottom: 0px;
}

::v-deep .vs__dropdown-toggle {
  max-width: 400px;
  height: auto !important;
  padding: 0;
  min-width: 120px;
  background-color: #FFFFFF;
  border-radius: 50px;
}

::v-deep .divider.theme--light.v-divider {
  background-color: #62BDBD;
}

::v-deep .btn.secondary {
  border: #5D409F solid 1px;
  border-radius: 25px;
  color: #5D409F
}

::v-deep .custom-textarea {
  min-height: 140px !important;
}

.v-card-text::-webkit-scrollbar {
  display: none;
}

.main-container-spacing {
  margin: 0px 30px 20px 30px;
  padding-top: 20px;
}

.custom-textarea {
  width: 100%;
  min-height: 186px;
}

.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  border: 2px solid #D0D0D0;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
}

.employee-details {
  display: flex;
  flex-direction: column;
}

.employee-details-heading {
  margin-top: 5px;
  color: #7C7C7C;
  font-size: 18px;
}

.circle-wrapper {
  position: relative;
  display: inline-block;
}

.v-select.v-select--chips .v-select__selections {
  color: #7C7C7C;
}

.tooltip {
  visibility: hidden;
  background-color: white;
  color: black;
  text-align: left;
  border-radius: 5px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: visibility 0.2s ease-in-out;
}

.circle-wrapper:hover .tooltip {
  visibility: visible;
}

::v-deep .v-input__slot:before {
  width: 0 !important;
}

::v-deep .v-input__slot:after {
  width: 0 !important;
}

::v-deep .btn.primary {
  border-radius: 50px;
}

::v-deep .v-icon {
  color: #5D409F !important;
  margin-top: 8px;
}

::v-deep .v-select__slot {
  margin-top: 15px;
}

::v-deep .v-select__slot:after {
  margin-bottom: 10px;
}

::v-deep .v-text-field {
  padding-top: 0px !important;
  margin-top: 8px;
}

::v-deep .v-text-field .v-label {
  font-size: 14px;
}

::v-deep .btn {
  padding-top: 12px;
  padding-bottom: 12px;
}

.payroll-row {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.process-payroll-container {
  background: white;
  // min-width: 30%;
  // gap: 5px;
  align-items: center;
  width: 504px;
  //max-width: 32%;
  min-height: 270px;
  padding: 24px 54px;
  display: flex;
  justify-content: space-between;
  max-height: 260px;
  border: 2px solid #eeeeee;
  border-radius: 18px;
}

.totl-emp {
  color: #5D409F;
  font-size: 18px;
  font-weight: bold;
}

// .emp-payrolltxt {
//   color: #62BDBD;
//   font-weight: 500;
//   font-size: 18px;
// }

.employee-ptext {
  font-size: 18px;
  margin-bottom: 0px;
  text-wrap: nowrap;
  color: #62BDBD;
  font-weight: 500;
}

.employee-overflow {
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
}

.employee-ratio {
  display: flex;
  gap: 5px;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}

.gross-items {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.gross-outer-container {
  display: flex;
  gap: 20px;
  align-items: center;
}

// .doughnut-container {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   gap: 90px;
// }

.small-boxes {
  display: flex;
  flex-direction: column;
  gap: 15px;
  // align-items: flex-start;
  flex-grow: 1;
}

.small-box-with-text {
  display: flex;
  //flex-direction: column;
  align-content: center;
  width: 100%;
  gap: 12px;
}

.calender-days {
  margin-bottom: 0px;
  font-weight: 500;
  font-size: 16px;
  color: #59419A;
  text-align: start;
}

.gross-container {
  background: white;
  width: 100%;
  min-height: 230px;
  max-height: 230px;
  padding: 25px 25px;
  border: 2px solid #eeeeee;
  border-radius: 18px;
  //box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}

.employee-count {
  display: flex;
  gap: 8px;
  text-wrap: nowrap;
}

.employee-p {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 500;
  color: #5D409F;
}

.gross-inr {
  font-size: 14px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 8px;
  color: #7C7C7C;
}

.gross-value {
  margin-bottom: 0px;
  margin-top: 16px;
  color: #5D409F;
  font-size: 18px;
  font-weight: 500;
}

.income-container {
  display: flex;
  margin-top: 10px;
  gap: 10px;
}

.dashed-container {
  border: 1px dashed #C1C1C1;
  border-radius: 50px;
  width: 150px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 10px 15px;
}

.variation-ptext {
  font-size: 14px;
  font-weight: 400;
  color: #7C7C7C;
  margin: 0px;
}

.doughnut-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 5px;
}

.doughnut-progress {
  position: relative;
}

.doughnut-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  /* Adjust this size to ensure a visible gap */
  height: 80px;
  /* Adjust this size to ensure a visible gap */
  background-color: #F9F9F9;
  color: #4B4B4B;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  font-size: 20px;
  font-weight: bold;
}

.doughnut-wrapper::after {
  border-radius: 50px;
}

.curved-div {
  width: 210px;
  height: 40px;
  padding: 11px 20px;
  border: 1px solid #D0D0D0;
  border-radius: 25px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;

}

::v-deep.date-select .v-menu__content {
  left: 300px !important;
  top: 135px !important;
}

::v-deep.multi .v-menu>.v-menu__content {
  left: -50px !important;
  top: 65px !important;
  border-radius: 10px
}

// ::v-deep .box-auto .v-select__slot{
//   border: #D0D0D0 solid 1px;
//   border-radius: 5px;
// }

// ::v-deep .box-auto .v-select.v-text-field input {
// margin: 0px 5px;
// }
::v-deep .v-picker__title {
  padding: 0px !important;
}

::v-deep .v-date-picker-title__year {
  margin-bottom: 0px !important;
  display: none;
}

::v-deep .v-date-picker-title__date {
  margin-bottom: 0px !important;
  font-size: 0px !important;
  text-align: none !important;
  font-weight: 0 !important;
  position: none !important;
  overflow: none !important;
  padding-bottom: 0px !important;
}

::v-deep .v-dialog__content.v-dialog__content--active {
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
}

.dat-picker {
  width: 40px;
  border-radius: 5px;
}
.bold-text {
  font-weight: bold;
  color: red; /* Make it bold and more noticeable when under 10 characters */
}
.light-text {
  font-weight: normal;
  color: lightgray; /* Make it light when 10 or more characters */
}
</style>
